import { FC, useEffect, useState } from "react";
import transition from "../../components/transition";
import { isValidReq } from "../../utils/check-status";
import fetchGetPageContent from "../../utils/request/wp-get-page-content";
import "./mentions-legales.css";
import { animationScrollPage } from "../../utils/animations";
import Ariane from "../../components/ariane";

const MentionsLegales: FC = () => {
  const [data, setData] = useState();
  useEffect(() => {
    animationScrollPage();
  }, [data]);

  const wpPageID: number = 85;
  useEffect(() => {
    fetchGetPageContent(wpPageID).then((result) => {
      if (isValidReq(result.status)) {
        setData(result.data);
      }
    });
  }, []);

  return data ? (
    <article className="page scroll-container" data-router-view="custom" id="page-mention-legales">
      <div data-scroll>
        <Ariane name="Mentions Légales" />
        <section className="page__container">
          <div className="text-intro" dangerouslySetInnerHTML={{ __html: data }} />
        </section>
      </div>
    </article>
  ) : null;
};

export default transition(MentionsLegales);
